module.exports = __webpack_public_path__ + "img/Pag2_2.e7ec5609.png";